// extracted by mini-css-extract-plugin
export default {"loading":"gtbCustomize_loading__0x0zx"};